export default "__VITE_ASSET__06c5e17f__"